var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "b-row",
        { staticClass: "mb-3" },
        [
          _c(
            "b-col",
            {
              staticClass: "d-flex justify-content-start align-items-end",
              attrs: { cols: "6" },
            },
            [
              _c(
                "b-button",
                { attrs: { variant: "primary" }, on: { click: _vm.openModal } },
                [
                  _vm._v(
                    "\n                bezahl.de Org registrieren\n            "
                  ),
                ]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          attrs: {
            "hide-footer": "",
            size: "lg",
            title: "bezahl.de Organisation registrieren",
          },
          on: { hide: _vm.reset },
          model: {
            value: _vm.isModalOpen,
            callback: function ($$v) {
              _vm.isModalOpen = $$v
            },
            expression: "isModalOpen",
          },
        },
        [
          _c(
            "div",
            { staticClass: "loading-content-container" },
            [
              _vm.isLoading
                ? _c(
                    "div",
                    {
                      staticClass:
                        "loading-overlay d-flex justify-content-center pt-5",
                    },
                    [_c("csp-loading-indicator")],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              !_vm.isLoading
                ? _c(
                    "csp-desktop-info-card",
                    {
                      attrs: {
                        cols: 12,
                        "form-context": _vm.bezahlDeOrgFormContext,
                        icon: "inticon-autoclaim_distribution",
                        title: "bezahl.de Org",
                      },
                      on: {
                        "cancel-form": _vm.reset,
                        save: _vm.saveBezahlDeOrg,
                      },
                    },
                    [
                      _c(
                        "b-row",
                        [
                          _c("csp-desktop-info-card-element", {
                            staticClass: "col-12",
                            attrs: {
                              "form-context": _vm.bezahlDeOrgFormContext,
                              label: "Bezeichnung",
                              property: "description",
                              required: true,
                              type: "text",
                            },
                          }),
                          _vm._v(" "),
                          _c("csp-desktop-info-card-element", {
                            staticClass: "col-12",
                            attrs: {
                              "form-context": _vm.bezahlDeOrgFormContext,
                              label: "bezahl.de Org-ID",
                              property: "vendorId",
                              required: true,
                              type: "text",
                            },
                          }),
                          _vm._v(" "),
                          _c("csp-desktop-info-card-element", {
                            staticClass: "col-12",
                            attrs: {
                              "form-context": _vm.bezahlDeOrgFormContext,
                              label: "API-Token",
                              property: "apiToken",
                              required: true,
                              type: "password",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }